import React from 'react';
import { FaMoneyBillAlt } from "react-icons/fa";
import { MdMoneyOff } from "react-icons/md";
import { GiMoneyStack } from "react-icons/gi";
import { FaMoneyCheckAlt } from "react-icons/fa";
import { GiReceiveMoney } from "react-icons/gi";
import { NavLink } from 'react-router-dom'; // Import NavLink

import './layout.css'; // Make sure this path is correct

const PayrollInfoLayout = ({ children }) => {

  return (
    <div >
      <h1 className="layouts-title">
        <FaMoneyBillAlt 
        className="leave-policy-icon" />
        Payroll Information
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="payroll-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/payroll"
              >
                <GiMoneyStack  className="nav-icon" />Payroll
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="paid-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/paid"
              >
                <GiReceiveMoney className="nav-icon" /> Paid
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="al-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/"
              >
                <MdMoneyOff className="nav-icon" />UnPaid
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="emp-reports-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/emp-reports"
              >
                <FaMoneyCheckAlt className="nav-icon" />Reports
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">
          {children}
        </div>
      </section>
    </div>
  );
};

export default PayrollInfoLayout;
